import { ErrorInfo, useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

// Extracted from ErrorBoundary.tsx so that file exports only the class component
// (react-refresh/only-export-components — a class component alongside this function
// component in one file breaks Fast Refresh).
interface ErrorFallbackProps {
  error?: Error;
  errorInfo?: ErrorInfo;
}

export function ErrorFallback({ error, errorInfo }: ErrorFallbackProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const isDev = import.meta.env.MODE === 'development';

  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="text-center p-8 max-w-2xl w-full">
        {/* Logo */}
        <img
          src="/assets/ht-logo.png"
          alt="Hollywood Trucks"
          className="h-14 w-auto mx-auto mb-16"
        />

        <h1 className="text-2xl font-bold text-[#8FB560] mb-8">
          Something went wrong
        </h1>

        <p className="text-muted-foreground mb-12">
          {error?.message || 'An unexpected error occurred'}
        </p>

        {/* Collapsible error details (dev only) */}
        {isDev && errorInfo && (
          <div className="mb-10">
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="flex items-center gap-2 mx-auto text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              {isExpanded ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
              {isExpanded ? 'Hide' : 'Show'} error details
            </button>

            {isExpanded && (
              <pre className="text-left text-xs bg-muted p-4 rounded mt-4 overflow-auto max-h-64">
                {errorInfo.componentStack}
              </pre>
            )}
          </div>
        )}

        <button
          onClick={() => window.location.reload()}
          className="px-6 py-2.5 bg-[#8FB560] text-black font-medium rounded hover:bg-[#7da54f] transition-colors"
        >
          Reload Page
        </button>
      </div>
    </div>
  );
}
